import React from "react";

// The SQL a SuperAdmin is about to run, shown before they run it. It lives with
// this screen rather than in `components/ui` because nothing else in the app
// shows a statement list yet.
//
// Every colour on this screen is a theme token, so the SQL block cannot be a
// fixed slate-950: that reads as a hole in the light theme. `background-tertiary`
// is the nested-surface token and carries `text-text-primary` in both themes.
const CodeBlock = ({ children }) => (
  <div className="rounded-md border border-border-primary bg-background-tertiary text-text-primary p-3 max-h-64 overflow-auto text-xs font-mono">{children}</div>
);

export default CodeBlock;
